export default __webpack_public_path__ + "static/media/Ficha_garbanzo.e8331872.png";